<div class="card">
  <div class="card-header row gy-2 gy-md-4 gx-3">
    <div class="col-auto my-auto">
      <h4 class="mb-0">Subscriptions</h4>
    </div>
    <div class="col-12 col-sm-3">
      <div class="form-floating">
        <select
          class="form-select select-not-empty"
          name="productFilter"
          [(ngModel)]="productFilter"
          (ngModelChange)="filtersChanged()"
        >
          <option [ngValue]="null">All</option>
          <option *ngFor="let type of productTypes" [ngValue]="type">
            {{ productLabel(type) }}
          </option>
        </select>
        <label>Product</label>
      </div>
    </div>
    <div class="col-12 col-sm-3">
      <div class="form-floating">
        <select
          class="form-select select-not-empty"
          name="statusFilter"
          [(ngModel)]="statusFilter"
          (ngModelChange)="filtersChanged()"
        >
          <option [ngValue]="null">All</option>
          <option *ngFor="let status of statuses" [ngValue]="status">
            {{ status }}
          </option>
        </select>
        <label>Status</label>
      </div>
    </div>
    <app-paginator
      class="col-auto ms-auto"
      [data]="subscriptionsPage"
      [pageable]="pageable"
      (newPage)="switchPage($event)"
    ></app-paginator>
  </div>
  <div class="card-body">
    <span *ngIf="!subscriptionsPage?.content?.length">
      No subscriptions match the selected filters.
    </span>
    <div *ngIf="subscriptionsPage?.content?.length" class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr class="table-row table-row-head text-nowrap">
            <th>Person</th>
            <th>Product</th>
            <th>Status</th>
            <th>Renewal</th>
            <th>Started</th>
            <th>Paid until</th>
            <th>Renewals</th>
            <th></th>
          </tr>
        </thead>
        <tbody class="table-body">
          <tr *ngFor="let subscription of subscriptionsPage.content" class="table-row">
            <td class="text-nowrap">{{ personName(subscription) }}</td>
            <td class="text-nowrap">{{ productLabel(subscription.productType) }}</td>
            <td>{{ subscription.status }}</td>
            <td class="text-nowrap">
              <span
                *ngIf="subscription.renewalStopped"
                class="badge xsmall rounded-2 bg-warning text-dark"
                title="Renewals were deliberately stopped; the subscription will not come back automatically"
              >
                stopped
              </span>
              <span *ngIf="!subscription.renewalStopped && !subscription.renewal.autoRenew" class="text-muted">
                off
              </span>
              <ng-container *ngIf="!subscription.renewalStopped && subscription.renewal.autoRenew">
                {{ renewalRuleLabel(subscription) }}
              </ng-container>
            </td>
            <td class="text-nowrap">{{ subscription.startDate | date : 'd/MM/yyyy' }}</td>
            <td class="text-nowrap">{{ subscription.expiryDate | date : 'd/MM/yyyy' }}</td>
            <td>{{ subscription.renewalCount }}</td>
            <td class="text-end">
              <div class="dropleft d-inline-block">
                <a
                  class="btn btn-outline-secondary-2 rounded-circle p-2"
                  [attr.id]="'subscriptionMenu-' + subscription.id"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-reference="parent"
                >
                  <app-icon name="more-vertical" class="icon-primary"></app-icon>
                </a>
                <div class="dropdown-menu p-2 rounded-3" [attr.aria-labelledby]="'subscriptionMenu-' + subscription.id">
                  <a
                    class="dropdown-item px-3 py-2 rounded-3 cursor-pointer"
                    (click)="openRuleEditor(subscription)"
                  >
                    Renewal rule
                  </a>
                  <!-- the tooltip sits on the wrapper because the disabled item itself is pe-none -->
                  <span [title]="hasMemberProducts(subscription) ? '' : missingMemberTooltip(subscription)">
                    <a
                      class="dropdown-item px-3 py-2 rounded-3"
                      [ngClass]="hasMemberProducts(subscription) ? 'cursor-pointer' : 'disabled pe-none'"
                      (click)="openMemberProducts(subscription)"
                    >
                      Member products
                    </a>
                  </span>
                  <a
                    class="dropdown-item px-3 py-2 rounded-3 cursor-pointer"
                    (click)="showHistory(subscription)"
                  >
                    Subscription history
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-subscription-rule-modal
  #ruleEditor
  [schoolId]="schoolId"
  (saved)="onRuleSaved($event)"
></app-subscription-rule-modal>

<app-modal #historyModal size="xl">
  <div class="modal-content">
    <div class="modal-header">
      <div>
        <h5 class="modal-title fw-bold" *ngIf="historySubscription">
          History — {{ personName(historySubscription) }} &middot;
          {{ productLabel(historySubscription.productType) }}
        </h5>
        <span class="text-muted small">Every recorded event of this subscription</span>
      </div>
      <button
        type="button"
        class="btn-close"
        (click)="historyModal.hide()"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <div *ngIf="historyLoading" class="d-flex py-4">
        <div class="spinner-border text-primary mx-auto" role="status" aria-hidden="true"></div>
      </div>
      <span *ngIf="!historyLoading && !historyEvents.length">
        No events recorded for this subscription.
      </span>
      <div *ngIf="!historyLoading && historyEvents.length" class="table-responsive">
        <table class="table table-sm">
          <thead>
            <tr class="table-row table-row-head text-nowrap">
              <th>Event</th>
              <th>Billing month</th>
              <th>Effective date</th>
              <th>Paid until</th>
              <th>Recorded</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr *ngFor="let event of historyEvents" class="table-row">
              <td>
                <span
                  class="text-uppercase badge xsmall rounded-2 w-fit-content"
                  [ngClass]="eventBadgeClass(event)"
                >
                  {{ eventLabel(event) }}
                </span>
              </td>
              <td>{{ event.billingMonth }}</td>
              <td class="text-nowrap">{{ event.effectiveDate | date : 'd/MM/yyyy' }}</td>
              <td class="text-nowrap">{{ event.newExpiryDate | date : 'd/MM/yyyy' }}</td>
              <td class="text-nowrap">{{ event.eventDate | date : 'd/MM/yyyy HH:mm' }}</td>
              <td>{{ event.notes }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</app-modal>
